<script>
import ShiftInfoComponent from '@/components/ShiftInfoComponent'
import RightLayout from '../layouts/rightLayout'
import {DateUtil} from '@/utils/date.js'

export default {
  components: {ShiftInfoComponent, RightLayout},
  data () {
    return {
      // 便情報
      shiftBasicModel: {
        // 便Id(重新生成)
        shiftId: '',
        // 便名称（update）
        title: '',
        // ルートID
        routeId: '',
        // ルートName
        routeName: '',
        // ドライバーUID  （update）
        driverUid: '',
        // 車両ID  （update）
        vehicleId: '',
        // 運行日
        moveShiftTime: '',
        // 行帰フラグ
        shiftFlag: '0',
        // 出発予定時台  (对应shiftFlag: '0'  ？？？？？？写下面还是上面)
        startEstimateTimeSlot: '',
        // 到着予定時台 (对应shiftFlag: '1'  ？？？？？？？)
        arriveEstimateTimeSlot: '',
        // 利用料金  （update）
        shiftCost: '',
        // 予約者数
        // reserveNumber: 0,
        // イベントID
        eventId: '',
        // フリガナ
        driverKanaName: '',
        // ドライバー
        driverName: '',
        // 車両？？？？
        vehicleName: '',
        // 車両定員人数？？？？
        passengerNumber: '',
        // 便タイプ
        shiftType: '',
        // 公開フラグ
        openFlag: 0,
        // 地区ID
        areaId: null,
        // 地区名
        areaName: '',
        // コメント
        comment: '',

      },
      // 便経由地情報(如果分开请求后台时，别忘记添加shiftId)
      shiftPasspoint: {
        // 便Id
        // shiftId: '',
        // 経由地番号
        // routeNo: '',
        // 順番  （update，只是把乘车人顺番交换以及出发、到着予定或到着日时更换）
        // sortNo: '',
        // 出発予定日時 （update）
        startEstimateTime: '',
        // 到着予定日時 （update）
        arriveEstimateTime: '',
        name: '',
        // 经度
        stationLat: 0.00,
        // 纬度
        stationLng: 0.00
      },
      shiftList: [{
        frontId: '0000',
        shiftEvent: null,
        shiftBasic: {},
                      // shiftPasspoint
        shiftPasspointList: [],
        functionFlag: '0',
        loopDateList: null,
        // shiftReservationInfos
        shiftReservationInfoList: [],
        // 時刻リスト
        hourList: [],
        minuteList: [],
        timeList: [],
        shiftTimeInfoList: [],
        // ドライバー情報
        shiftTimeInfoListByDriverUid: [],
        // 車両情報
        selectedVehicle: [],
        // ドライバーアプリ使用有無 1:ドライバーアプリ使用 2:未使用
        routeType: '',
        // ルート選択フラグ
        routeSelected: false,
        // 停留所一覧
        stationList: [{
          routeId: '',
          routeName: '',
          stationName: '',
        }],
        transportKind: 0,
        parentShiftId: '',
        // コメント
        comment: '',
        }],

    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      let shiftDetail = JSON.parse(sessionStorage.getItem('shiftDetail'))
      console.log("shiftAdd created getData")
      console.log("shiftDetail")
      console.log(shiftDetail)
      let shiftInfo = shiftDetail.shiftInfo
      this.shiftBasicModel.shiftId = ''
      this.shiftBasicModel.oldShiftId = shiftInfo.shiftId
      this.shiftBasicModel.tempShiftId = shiftInfo.shiftId
      this.shiftBasicModel.title = shiftInfo.title
      this.shiftBasicModel.routeId = shiftInfo.routeId
      // 获取route下拉框和停留所相关信息
      // let routeStationInfo = JSON.parse(sessionStorage.getItem('routeStationInfo'))
      // for (let i = 0; i < routeStationInfo.length; i++) {
      //   if (routeStationInfo[i].routeId === shiftInfo.routeId) {
      //     this.shiftBasicModel.routeName = routeStationInfo[i].routeName
      //     break
      //   }
      // }
      // 获取route-name
      if (this.shiftBasicModel.routeId !== null && this.shiftBasicModel.routeId !== '') {
        this.$axios.get('shift/queryRouteNameById', {params: {routeId: this.shiftBasicModel.routeId}})
          .then(response => {
            this.shiftBasicModel.routeName = response.data.routeName
          })
          .catch(function (error) {
            console.log(error)
          })
      }
      // 默认不选
      // this.shiftBasicModel.driverUid = shiftInfo.driveUid
      // this.shiftBasicModel.vehicleId = shiftInfo.vehicleId

      this.shiftBasicModel.moveShiftTime = DateUtil.getYearMonthDay(shiftInfo.moveShiftTime)
      this.shiftBasicModel.shiftFlag = String(shiftInfo.shiftFlag)
      if (shiftInfo.shiftFlag === '0') {
        this.shiftBasicModel.startEstimateTimeSlot = shiftInfo.startEstimateTimeSlot
      } else {
        this.shiftBasicModel.arriveEstimateTimeSlot = shiftInfo.arriveEstimateTimeSlot
      }
      // 初始值为300，不取元便利用料金
      this.shiftBasicModel.shiftCost = 300

      this.shiftBasicModel.eventId = shiftInfo.eventId
      // 默认不选
      // this.shiftBasicModel.driverKanaName = shiftInfo.driverNameKana
      // this.shiftBasicModel.driverName = shiftInfo.driverName
      // this.shiftBasicModel.vehicleName = shiftInfo.vehicleName
      this.shiftBasicModel.passengerNumber = shiftInfo.passengerNumber
      this.shiftBasicModel.shiftType = shiftInfo.shiftType
      this.shiftBasicModel.openFlag = shiftInfo.openFlag
      //  this.$refs.shiftAddCom.getShiftPasspoints()
      this.shiftBasicModel.areaId = shiftInfo.areaId
      this.shiftBasicModel.areaName = shiftInfo.areaName

      // 地域外交通対応
      this.shiftList[0].shiftBasic.shiftId = shiftInfo.shiftId
      this.shiftList[0].shiftBasic.oldShiftId = shiftInfo.shiftId

      this.shiftList[0].shiftBasic.title = shiftInfo.title
      this.shiftList[0].shiftBasic.routeId = shiftInfo.routeId
      // this.shiftList[0].shiftBasic.driverUid = shiftInfo.driveUid
      // this.shiftList[0].shiftBasic.vehicleId = shiftInfo.vehicleId
      this.shiftList[0].shiftBasic.moveShiftTime =  DateUtil.getYearMonthDay(shiftInfo.moveShiftTime)
      this.shiftList[0].shiftBasic.shiftFlag = String(shiftInfo.shiftFlag)
      if (shiftInfo.shiftFlag == '0') {
        this.shiftList[0].shiftBasic.startEstimateTimeSlot = shiftInfo.startEstimateTimeSlot
      } else {
        this.shiftList[0].shiftBasic.arriveEstimateTimeSlot = shiftInfo.arriveEstimateTimeSlot
      }
      this.shiftList[0].shiftBasic.shiftCost = shiftInfo.shiftCost
      if (shiftInfo.shiftReservationInfos.length > 0) {
        this.shiftList[0].shiftBasic.reserveNumber = shiftInfo.reserveNumber
      } else {
        this.shiftList[0].shiftBasic.reserveNumber = 0
      }

      this.shiftList[0].shiftBasic.eventId = shiftInfo.eventId
      // ドライバーと車両は渡さず、新しく入力させる
      // this.shiftList[0].shiftBasic.driverKanaName = shiftInfo.driverNameKana
      // this.shiftList[0].shiftBasic.driverName = shiftInfo.driverName
      // this.shiftList[0].shiftBasic.vehicleName = shiftInfo.vehicleName
      this.shiftList[0].shiftBasic.passengerNumber = shiftInfo.passengerNumber
      this.shiftList[0].shiftBasic.shiftType = shiftInfo.shiftType
      this.shiftList[0].shiftBasic.shiftMovementStatus = shiftInfo.shiftMovementStatus


      if (this.shiftList[0].shiftBasic.routeId !== null && this.shiftList[0].shiftBasic.routeId !== '') {
        this.$axios.get('shift/queryRouteNameById', {params: {routeId: this.shiftList[0].shiftBasic.routeId}})
          .then(response => {
            console.log('shift/queryRouteNameById')
            console.log(response.data.routeName)
            this.shiftList[0].shiftBasic.routeName = response.data.routeName
            // 描画更新
            this.shiftList.splice(0,this.shiftList)
          })
          .catch(function (error) {
            console.log(error)
          })
      }else{
        this.shiftList[0].shiftBasic.routeName = JSON.parse(sessionStorage.getItem('routeName'))
      }
      this.shiftList[0].shiftBasic.areaId = shiftInfo.areaId
      this.shiftList[0].shiftBasic.areaName = shiftInfo.areaName
      this.shiftList[0].shiftBasic.businessStatus = shiftInfo.businessStatus

      this.shiftList[0].shiftBasic.transportKind = shiftInfo.transportKind
      this.shiftList[0].shiftBasic.parentShiftId = shiftInfo.parentShiftId
      this.shiftList[0].shiftBasic.comment = shiftInfo.comment

            
    }
  }
}
</script>

<template>
<right-layout>
<Shift-info-component
    :title="'便を登録(増便)'"
    :btnName="'登録'"
    :functionFlag="'3'"
    :shiftList=shiftList
    ></Shift-info-component>
</right-layout>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/router/views/ShiftAdd.vue